import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './styles.css';
import './main.css';

const placementOptions = [
  { value: 'sidebar', label: 'サイドバー広告' },
  { value: 'journal', label: 'Journal（聖書新聞）記事内' },
  { value: 'bible', label: 'Bibleページ内' },
  { value: 'sermon', label: 'Sermonページ内' },
  { value: 'blog', label: 'Blogページ内' },
];

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    contactMethod: '',
    placement: [],
    message: '',
    budget: '',
  });
  const [status, setStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const togglePlacement = (value) => {
    setFormData((prev) => {
      const exists = prev.placement.includes(value);
      const nextPlacement = exists
        ? prev.placement.filter((item) => item !== value)
        : [...prev.placement, value];
      return { ...prev, placement: nextPlacement };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus(null);

    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim() || !formData.placement.length) {
      setStatus({ type: 'error', message: 'お名前、メールアドレス、掲載希望枠、本文は必須です。' });
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name.trim(),
          email: formData.email.trim(),
          organization: formData.organization.trim(),
          contactMethod: formData.contactMethod.trim(),
          placement: formData.placement,
          message: formData.message.trim(),
          budget: formData.budget.trim(),
        }),
      });

      if (!response.ok) {
        throw new Error('failed');
      }

      setFormData({
        name: '',
        email: '',
        organization: '',
        contactMethod: '',
        placement: [],
        message: '',
        budget: '',
      });
      setStatus({ type: 'success', message: '送信しました。折り返しのご連絡をお待ちください。' });
    } catch (error) {
      setStatus({ type: 'error', message: '送信に失敗しました。時間をおいて再度お試しください。' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="body">
      <Helmet>
        <title>広告お問い合わせ - ASMRキリスト教会</title>
        <meta name="description" content="ASMRキリスト教会への広告掲載・タイアップのご相談フォーム。サイドバー、Journal、Bibleなどの掲載場所を指定してお問い合わせいただけます。" />
      </Helmet>
      <Header subon={false} />
      <div className="container" style={{ padding: '20px' }}>
        <div style={{ maxWidth: '840px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 3px 10px rgba(0,0,0,0.08)', padding: '30px' }}>
          <h1 style={{ marginBottom: '12px', textAlign: 'center' }}>広告お問い合わせ</h1>
          <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
            ASMRキリスト教会ではWebサイト・アプリでの広告掲載、タイアップ、メディア露出のご相談を受け付けています。
            下記フォームからお気軽にお問い合わせください。
          </p>

          <div style={{ border: '1px solid #f0c040', borderRadius: '6px', padding: '16px', backgroundColor: '#fffaf0', marginBottom: '24px' }}>
            <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.7 }}>
              送信内容は<code style={{ background: 'transparent', fontFamily: 'inherit', color: '#b45309' }}> kei@sugano.works </code>に転送されます。
              1〜2営業日以内を目安に担当者より折り返しご連絡いたします。
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="name" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>お名前<span style={{ color: '#d00', marginLeft: '4px' }}>*</span></label>
              <input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="email" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>メールアドレス<span style={{ color: '#d00', marginLeft: '4px' }}>*</span></label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="organization" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>会社名・ご所属</label>
              <input
                id="organization"
                name="organization"
                type="text"
                value={formData.organization}
                onChange={handleChange}
                placeholder="任意"
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="contactMethod" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>ご希望の連絡方法</label>
              <input
                id="contactMethod"
                name="contactMethod"
                type="text"
                value={formData.contactMethod}
                onChange={handleChange}
                placeholder="電話番号、SNS、その他"
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ marginBottom: '18px' }}>
              <span style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>掲載希望枠<span style={{ color: '#d00', marginLeft: '4px' }}>*</span></span>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {placementOptions.map((option) => (
                  <label key={option.value} style={{ display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: '#f8f8f8', padding: '8px 12px', borderRadius: '20px', cursor: 'pointer', border: formData.placement.includes(option.value) ? '1px solid #f0c040' : '1px solid #ddd' }}>
                    <input
                      type="checkbox"
                      checked={formData.placement.includes(option.value)}
                      onChange={() => togglePlacement(option.value)}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="budget" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>ご予算の目安</label>
              <input
                id="budget"
                name="budget"
                type="text"
                value={formData.budget}
                onChange={handleChange}
                placeholder="例：月額◯万円、インプレッション保障など"
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
              />
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label htmlFor="message" style={{ display: 'block', fontWeight: 'bold', marginBottom: '6px' }}>お問い合わせ内容<span style={{ color: '#d00', marginLeft: '4px' }}>*</span></label>
              <textarea
                id="message"
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', resize: 'vertical' }}
              />
            </div>

            {status && (
              <div
                style={{
                  marginBottom: '18px',
                  padding: '12px',
                  borderRadius: '4px',
                  backgroundColor: status.type === 'success' ? '#e0f2f1' : '#fdecea',
                  color: status.type === 'success' ? '#0f766e' : '#b91c1c',
                  border: status.type === 'success' ? '1px solid #0f766e' : '1px solid #f87171',
                }}
              >
                {status.message}
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                width: '100%',
                backgroundColor: isSubmitting ? '#999' : '#f0c040',
                border: 'none',
                padding: '12px',
                borderRadius: '4px',
                fontWeight: 'bold',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                color: '#222',
                fontSize: '16px',
              }}
            >
              {isSubmitting ? '送信中...' : '送信する'}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
